<template>
  <nav style="--bs-breadcrumb-divider: '>'">
    <ol class="breadcrumb small">
      <li
        class="breadcrumb-item"
        :class="{ active: index === crumbs.length - 1 }"
        :key="crumb"
        v-for="(crumb, index) in crumbs"
      >
        {{ crumb }}
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    crumbs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
